import { Pivot, PivotItem } from "@fluentui/react";
import { productFamilies } from "../../../helper/ProductFamilies";
import { useGetUIEnablementsSettingsQuery } from "../../../slices/Home.slice";
import { buildDisabledFeatureLookup } from "../../../Utils/js-common";
import { pivotStyles } from "./FeaturePivot.styles";
import { FeaturePivotProps } from "./FeaturePivot.types";

export default function FeaturePivot({ selectedFamily, setSelectedFamily }: FeaturePivotProps) {
  const uiEnablementData = useGetUIEnablementsSettingsQuery(undefined)?.data || [];
  const disabled = buildDisabledFeatureLookup(uiEnablementData);
  const disabledSections = disabled["section"] || [];
  const filteredCustomerFamilies = productFamilies.filter(
    ({ name }) =>
      !disabledSections
        .filter(({ feature, tab }) => feature === "Explore Customers" && tab === "Features Telemetry")
        .map((m) => m.section)
        .includes(name)
  );

  return (
    <Pivot
      selectedKey={selectedFamily}
      onLinkClick={(item) => {
        if (item) {
          setSelectedFamily(item.props.itemKey!);
        }
      }}
      styles={pivotStyles}
    >
      {filteredCustomerFamilies.map((family) => (
        <PivotItem key={family.key} itemKey={family.key} headerText={family.name} />
      ))}
    </Pivot>
  );
}
